module.exports = __webpack_public_path__ + "chat-bg.b04e814510747fb82cb1.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/assets/images/chat-bg.jpg
// module id = ../../../../../src/assets/images/chat-bg.jpg
// module chunks = styles